import ChevroneRightIcon from '@common/assets/icons/chevrone_right.svg?react';
import kebab from '@common/assets/icons/kebab.svg';
import { CachedImage } from '@common/ui/CachedImage';
import { DynamicImage } from '@common/ui/DynamicImage';
import { Icon } from '@common/ui/Icon';

import { useChatSafetyContext } from '@entities/chat/contexts';

import { type User } from '@services/UsersService';

import styles from './ChatTopLine.module.scss';

export type ChatTopLineProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  profile: User;
};

export const ChatTopLine: React.FC<ChatTopLineProps> = ({
  profile,
  ...props
}) => {
  const { updateChatSafetyState } = useChatSafetyContext();

  return (
    <div {...props} className={styles.chatTopLine}>
      <DynamicImage
        src={profile.photos[0]}
        className={styles.picture}
        alt={`avatar-${profile?.username}`}
        testId="chat-top-line-avatar"
      />
      <div className={styles.info}>
        <div className={styles.name} data-test-id="chat-top-line-name">
          {profile.username}, {profile.age}
        </div>

        {profile.is_premium && (
          <CachedImage
            testId="chat-top-line-premium-badge"
            alt="badge"
            src="/icons/3d-icons/fire.png"
            blur="2px"
            style={{ width: '24px' }}
          />
        )}
        {profile.is_verified && (
          <CachedImage
            testId="chat-top-line-verified-badge"
            alt="badge"
            src="/icons/3d-icons/confirmed.png"
            blur="2px"
            style={{ width: '24px' }}
          />
        )}
        <ChevroneRightIcon
          color={'var(--text-tetriary-transparent)'}
          width={16}
        />
      </div>
      <div
        data-test-id="chat-top-line-controls"
        className={styles.controls}
        onClick={(e) => {
          e.stopPropagation();
          updateChatSafetyState('isDialog', 'toggle');
        }}
      >
        <Icon testId="chat-top-line-kebab-icon" image={kebab} />
      </div>
    </div>
  );
};
